import { ChangeDetectionStrategy, Component } from '@angular/core';
import { LogoComponent } from '../../components/logo/logo.component';
import { ProjectsHeaderComponent } from '../projects-header/projects-header.component';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  standalone: true,
  imports: [LogoComponent, ProjectsHeaderComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderComponent {
  constructor() { }
}
